import { render, staticRenderFns } from "./WeeklyReportViewGlobal.vue?vue&type=template&id=5ad3a13c"
import script from "./WeeklyReportViewGlobal.vue?vue&type=script&lang=js"
export * from "./WeeklyReportViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports